import React, { useEffect, useState } from 'react';
import { TIPOS_ATIVIDADE } from '../../../constants/tipoAtividade';
import { FILTROS_DO_PAINEL, STATUS_FILTRO } from './constantes';
import {
  Acoes,
  BotaoPrimario,
  BotaoSecundario,
  Campo,
  CampoData,
  GrupoDeCaixas,
  Painel,
  Selecao,
} from './estilos';

const doPainel = (filtros) =>
  Object.fromEntries(FILTROS_DO_PAINEL.map((chave) => [chave, filtros[chave]]));

const vazio = Object.fromEntries(FILTROS_DO_PAINEL.map((chave) => [chave, chave === 'status' ? [] : '']));

const PainelFiltros = ({ filtros, opcoes, onAplicar }) => {
  const [rascunho, setRascunho] = useState(() => doPainel(filtros));
  const filtrosAplicados = JSON.stringify(doPainel(filtros));

  useEffect(() => {
    setRascunho(JSON.parse(filtrosAplicados));
  }, [filtrosAplicados]);

  const alterar = (chave) => (evento) => setRascunho((atual) => ({ ...atual, [chave]: evento.target.value }));

  const alternarStatus = (valor) =>
    setRascunho((atual) => ({
      ...atual,
      status: atual.status.includes(valor)
        ? atual.status.filter((status) => status !== valor)
        : [...atual.status, valor],
    }));

  const periodoInvertido =
    rascunho.periodoInicio && rascunho.periodoFim && rascunho.periodoInicio > rascunho.periodoFim;

  return (
    <Painel aria-label="Filtros do relatório">
      <GrupoDeCaixas>
        <legend>Status</legend>
        {STATUS_FILTRO.map(({ valor, rotulo }) => (
          <label key={valor}>
            <input
              type="checkbox"
              checked={rascunho.status.includes(valor)}
              onChange={() => alternarStatus(valor)}
            />
            {rotulo}
          </label>
        ))}
      </GrupoDeCaixas>

      <Campo>
        Especialidade
        <Selecao value={rascunho.areaCursoId} onChange={alterar('areaCursoId')}>
          <option value="">Todas</option>
          {opcoes.areas.map((area) => (
            <option key={area.id} value={area.id}>{area.nome}</option>
          ))}
        </Selecao>
      </Campo>

      <Campo>
        Tipo
        <Selecao value={rascunho.tipoAtividade} onChange={alterar('tipoAtividade')}>
          <option value="">Todos</option>
          {TIPOS_ATIVIDADE.map((tipo) => (
            <option key={tipo.valor} value={tipo.valor}>{tipo.rotulo}</option>
          ))}
        </Selecao>
      </Campo>

      <Campo>
        Setor
        <Selecao value={rascunho.unidadeAssistencialId} onChange={alterar('unidadeAssistencialId')}>
          <option value="">Todos</option>
          {opcoes.setores.map((setor) => (
            <option key={setor.id} value={setor.id}>{`${setor.nome} (${setor.especialidade})`}</option>
          ))}
        </Selecao>
      </Campo>

      <Campo>
        Período de
        <CampoData type="date" value={rascunho.periodoInicio} onChange={alterar('periodoInicio')} />
      </Campo>

      <Campo>
        até
        <CampoData type="date" value={rascunho.periodoFim} onChange={alterar('periodoFim')} />
      </Campo>

      <Acoes>
        <BotaoSecundario type="button" onClick={() => onAplicar(vazio)}>
          Limpar
        </BotaoSecundario>
        <BotaoPrimario
          type="button"
          disabled={Boolean(periodoInvertido)}
          title={periodoInvertido ? 'O início do período deve ser anterior ou igual ao fim.' : undefined}
          onClick={() => onAplicar(rascunho)}
        >
          Aplicar
        </BotaoPrimario>
      </Acoes>
    </Painel>
  );
};

export default PainelFiltros;
